import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom'
import MainService from "../services/main-service";
import Loader from "../components/Loader";
import InviteUserForm from "./InviteUserForm";
import LinkedAccountDesc from "./LinkedAccountDesc";
import "./style/visenze.css";
import { OpenInNew, HelpOutline } from "@mui/icons-material";
import { Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export default function Visenze() {
  const [pageLoading, setPageLoading] = useState(true);
  const [visenzeAccount, setVisenzeAccount] = useState(undefined);
  const [userEmail, setUserEmail] = useState(undefined);
  const [shopOwner, setShopOwner] = useState(undefined);
  const [showDifferentSalesChannelDialog, setShowDifferentSalesChannelDialog] = useState(false);

  const { application_id } = useParams();

  useEffect(() => {
    fetchVisenzeDependencies();
  }, []);

  const fetchVisenzeDependencies = async () => {
    let visenzeAccount;
    try {
      const visenzeAccountRes = await MainService.getVisenzeAccount();
      if (visenzeAccountRes !== undefined) {
        visenzeAccount = visenzeAccountRes.data.result;
        setVisenzeAccount(visenzeAccountRes.data.result);
        setUserEmail(visenzeAccount.connector_info.email);
        setShopOwner(visenzeAccount.connector_info.shop_owner);
        // check if account is linked
        const visenzeAccountApplicationId = getVisenzeAccountApplicationId(visenzeAccount);
        if (visenzeAccount.linked && `${visenzeAccountApplicationId}` !== `${application_id}`) {
          setShowDifferentSalesChannelDialog(true);
        } else if (!visenzeAccount.linked || `${visenzeAccountApplicationId}` !== `${application_id}`) {
          // link visenze account
          const linkVisenzeAccountRes = await MainService.linkVisenzeAccount(application_id);
          if (linkVisenzeAccountRes !== undefined) {
            visenzeAccount = linkVisenzeAccountRes.data.result;
            setVisenzeAccount(linkVisenzeAccountRes.data.result);
            // inject the tracking scripts to new sales channel
            await MainService.injectTrackingScripts(application_id);
          }
        }
      }
    } catch (e) {
      if (e.response.status >= 500) {
        throw e;
      } else if (e.response.status === 404) {
        // create account if not exists
        const createAccountRes = await MainService.createVisenzeAccount(application_id);
        if (createAccountRes !== undefined) {
          setVisenzeAccount(createAccountRes.data.result);
          setUserEmail(createAccountRes.data.result.connector_info.email);
          setShopOwner(createAccountRes.data.result.connector_info.shop_owner);
          // inject tags to for add_to_cart, transaction events
          await MainService.injectTrackingScripts(application_id);
        }
      }
    } finally {
      setPageLoading(false);
    }
  }

  const getVisenzeAccountApplicationId = (visenzeAcc) => {
    return visenzeAcc && visenzeAcc.connector_info && visenzeAcc.connector_info.linked_apps
            && visenzeAcc.connector_info.linked_apps.length > 0
              ? visenzeAcc.connector_info.linked_apps[0].app_id : undefined;
  }

  const sectionMarkup = pageLoading ? (
    <Loader />
  ) : (
    <>
      <Dialog
        open={showDifferentSalesChannelDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span style={{fontSize: '14px'}}>
            {"Found active existing sales channel"}
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div style={{fontSize: '12px'}}>
              We found an active existing sales channel within the account. If you wish to install to the selected sales channel, please contact your admin.
            </div>
            <div style={{fontSize: '12px', marginTop: '8px'}}>
              Note: There could only be one store front installed at one time. To install to another store front, please uninstall and install on the new store front.
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {!showDifferentSalesChannelDialog &&
        <VisenzeContent
          visenzeAccount={visenzeAccount}
          userEmail = {userEmail}
          shopOwner = {shopOwner}
          showDifferentSalesChannelDialog = {showDifferentSalesChannelDialog}
        />
      }
      {!showDifferentSalesChannelDialog &&
        <div className="contact-us-section">
          <div className="contact-us-container">
            <HelpOutline color="primary" />
            <span className="need-help">Need help?</span>
            <a href="mailto:support@visenze.com" className="contact-us">
              Contact us
              <OpenInNew />
            </a>
          </div>
        </div>
      }
    </>
  );

  return (
    <>
      {sectionMarkup}
    </>
  );
}

const VisenzeContent = (props) => {
  const { visenzeAccount, userEmail, shopOwner } = props;
  const [form, setForm] = useState();

  const formRender = () => {
    if (visenzeAccount) {
      if (!visenzeAccount.linked) {
        // if account exists but not linked
        setForm('Account not linked.');
      } else if (visenzeAccount.state === 0) {
        // if account is linked and in pending status
        setForm(<InviteUserForm account={visenzeAccount} email={userEmail} owner={shopOwner} />);
      } else {
        // if account is linked and not pending
        setForm(<LinkedAccountDesc account={visenzeAccount} />);
      }
    } else {
      // if account does not exist
      setForm('Something went wrong.');
    }
  };

  useEffect(() => {
    formRender();
  }, [visenzeAccount, userEmail]);

  return (
    <>
      <div>{form}</div>
    </>
  );
};